<template>
	<div class="regist_fail" v-if="isShow">
		<button class="btn_close" @click="action_CloseExist"><v-icon small>mdi-close</v-icon></button>
		<div class="fail_desc">{{ $t('reservationwindow.reservationmonitor.already_registered_title') }}</div>
		<div class="user_info">
			<div class="user_info_item">
				<span class="name">{{ name }}</span>
				<span class="chartnum" v-if="usingChartNumber">({{ chartNumber }})</span>
				<span class="gen_birth">{{ genderBirthString }}</span>
			</div>
			<div class="user_info_item">
				<span class="label white"><v-icon x-small>mdi-cellphone</v-icon> {{ phone }}</span>
				<span class="label mgl_auto lgray_txt"><v-icon x-small>mdi-clock-outline</v-icon> {{ createdAt }}</span>
			</div>
		</div>
		<div class="button_group">
			<button class="btn btn_s btn_blue" @click="action_SelectService">
				{{ $t('reservationwindow.reservationmonitor.already_registered_button_regist_new_patient') }}
			</button>
		</div>
	</div>
</template>


<script>
import { formatGenderShort } from '@/util/format-gender'
import { formatPhone } from '@/util/format-phone'
import { toBirth6String } from '@/util/format-birth'
import { mapState } from "vuex";

const moment = require("@/util/MPMoment");

export default {
	props: {
		hservice: Object,
	},
	computed: {
		...mapState(["SaaS"]),

		isWindow: function () {
			return this.SaaS?.isWindow ?? false;
		},
		isShow: function () {
			return this.hservice?._id != undefined;
		},
		usingChartNumber: function () {
			return this.servicesetting?.setting?.usingChartNumber ?? false;
		},
		name: function () {
			return this.hservice.name;
		},
		chartNumber: function () {
			return this.hservice?.chartNumber ?? "";
		},
		gender: function () {
			return formatGenderShort(this.hservice.gender) ?? "-";
		},
		birth: function () {
			return toBirth6String(this.hservice.birth) ?? "-";
		},
		genderBirthString: function () {
			return this.gender + "/" + this.birth;
		},
		countries: function () {
			const list = this.$store.state.servicesetting.countries;
			return Array.isArray(list) ? list : [];
		},
		countryCodeId: function () {
			// KR fallback 을 두지 않는다 — 국가코드가 없으면 접두 없이 국내 포맷으로 표시 (기존 동작)
			return this.hservice.countryCode?._id;
		},
		countryDialingCode: function () {
			if (!this.isWindow) return "";

			const code = this.hservice?.countryCode?.internationalDialingCodes;
			if (code) {
				return `(+${code})`;
			}

			// 국가 목록 API 는 _id 를 countryId 로 리네임해 내려준다
			const country = this.countries.find(c => c.countryId == this.countryCodeId);
			if (country) {
				return `(+${country.internationalDialingCodes})`;
			}
			return "";
		},
		phone: function () {
			const phoneRaw = this.hservice.phone;
			if (!phoneRaw) return "-";

			if (this.countryDialingCode) {
				return `${this.countryDialingCode} ${phoneRaw}`;
			}
			return formatPhone(phoneRaw) ?? "";
		},
		createdAt: function () {
			return moment(this.hservice.createdAt).format(this.$t('common.date_format_YYYY_MM_DD_HH_mm'));
		},
	},
	methods: {
		action_CloseExist() {
			this.$emit("setHService", undefined);
		},
		action_SelectService() {
			this.$emit("setSelectedService", this.hservice);
		},
	},
};
</script>